import Home from './common/components/Home/Home'

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
